
// import { computed } from '@vue/composition-api'

export default function pastDateRange (props) {
  // TODO: Implement!
  return { minDateFrom: '', minDateTo: '', maxDateFrom: '' }
}



// WEBPACK FOOTER //
// ./src/app/shared/compositions/PastDateRange.js